// eslint-disable-file
import { Dependencies } from './dependencies';
import { ApiScenarioGateway } from '@secondaries/scenario/gateways/scenarios/api-scenario.gateway';
import { ApiZoneGateway } from '@secondaries/scenario/gateways/zones/api-zone.gateway';
import { ApiSourceGateway } from '@secondaries/scenario/gateways/source/api-source.gateway';
import { ApiBasecaseGateway } from '@secondaries/scenario/gateways/basecases/api-basecase.gateway';
import { ApiSubtypeGateway } from '@secondaries/scenario/gateways/subtypes/api-subtype.gateway';
import { XlsxExportGateway } from '@secondaries/scenario/gateways/export/xlsx-export.gateway';
import { ApiMarketAreaGateway } from '@secondaries/scenario/gateways/market-areas/api-market-area.gateway';
import { ApiRegionManagerGateway } from '@secondaries/scenario/gateways/region-manager/api-region-manager.gateway';
import { ApiUnitRatesGateway } from '@secondaries/scenario/gateways/unit-rates/api-unit-rates.gateway';
import { ApiUserPreferencesGateway } from '@secondaries/scenario/gateways/user-preferences/api-user-preferences.gateway';
import { ApiUserRolesGateway } from '@secondaries/scenario/gateways/user-roles/api-user-roles.gateway';
import { ApiSubscriptionGateway } from '@secondaries/scenario/gateways/subscription/api-subscription.gateway';
import { ApiWeatherYearGateway } from '@secondaries/scenario/gateways/weather-year/api-weather-year.gateway';
// eslint-disable-next-line
import { IncrementalIdProvider } from '@secondaries/scenario/providers/incremental-id.provider';
import { LocaleDateProvider } from '@secondaries/scenario/providers/locale-date.provider';
import { ApiFilteredReferentialsGateway } from '@secondaries/scenario/gateways/filter/api-filtered-referentials.gateway';
import { BrowserFileDownloader } from '@secondaries/price-card/providers/browser-file-downloader.provider';
import { ApiPriceCardDataGateway } from '@secondaries/price-card/gateways/price-card-data/api-price-card-data.gateway';
import { ApiPriceCardFileGateway } from '@secondaries/price-card/gateways/price-card-file/api-price-card-file.gateway';
import { ApiTechnologyGateway } from '@secondaries/price-card/gateways/technology/api-technology.gateway';
import { ApiPriceZoneGateway } from '@secondaries/price-card/gateways/price-zone/api-price-zone.gateway';
import { ApiCommercialOperationDateGateway } from '@secondaries/price-card/gateways/commercial-operation-date/api-commercial-operation-date.gateway';
import { ApiPriceCardSubscriptionGateway } from '@secondaries/price-card/gateways/subscription/api-price-card-subscription.gateway';
import { ApiReleaseDocumentationGateway } from '@secondaries/scenario/gateways/release-documentation/api-release-documentation.gateway';
import { ApiPmoGateway } from '@secondaries/scenario/gateways/pmo/api-pmo.gateway';
import { ApiAnalystGateway } from '@secondaries/scenario/gateways/analyst/api-analyst.gateway';
import { ApiPsfUserGateway } from '@secondaries/scenario/gateways/psf-user/api-psf-user.gateway';
import { ApiHourlyDataRequestGateway } from '@secondaries/scenario/gateways/hourly-data-request/api-hourly-data-request.gateway';
import { ApiHourlyRequestFilteredReferentialsGateway } from '@secondaries/scenario/gateways/hourly-request-filter/api-hourly-request-filtered-referentials.gateway';

export const productionDependencies: Dependencies = {
  scenarioGateway: new ApiScenarioGateway(),
  regionGateway: new ApiZoneGateway(),
  sourceGateway: new ApiSourceGateway(),
  basecaseGateway: new ApiBasecaseGateway(),
  subtypeGateway: new ApiSubtypeGateway(),
  exportGateway: new XlsxExportGateway(new LocaleDateProvider(navigator.language)),
  marketAreaGateway: new ApiMarketAreaGateway(),
  regionManagerGateway: new ApiRegionManagerGateway(),
  unitRatesGateway: new ApiUnitRatesGateway(),
  userPreferencesGateway: new ApiUserPreferencesGateway(),
  userRolesGateway: new ApiUserRolesGateway(),
  subscriptionGateway: new ApiSubscriptionGateway(),
  weatherYearGateway: new ApiWeatherYearGateway(),
  filteredReferentialsIdsGateway: new ApiFilteredReferentialsGateway(),
  idProvider: new IncrementalIdProvider(),
  technologyGateway: new ApiTechnologyGateway(),
  priceZoneGateway: new ApiPriceZoneGateway(),
  commercialOperationDateGateway: new ApiCommercialOperationDateGateway(),
  priceCardDataGateway: new ApiPriceCardDataGateway(),
  priceCardFileGateway: new ApiPriceCardFileGateway(new BrowserFileDownloader()),
  priceCardSubscriptionGateway: new ApiPriceCardSubscriptionGateway(),
  releaseDocumentationGateway: new ApiReleaseDocumentationGateway(new BrowserFileDownloader()),
  pmoGateway: new ApiPmoGateway(),
  analystGateway: new ApiAnalystGateway(),
  psfUserGateway: new ApiPsfUserGateway(),
  hourlyDataRequestGateway: new ApiHourlyDataRequestGateway(),
  hourlyRequestFilteredReferentialsIdsGateway: new ApiHourlyRequestFilteredReferentialsGateway(),
};
